(function(konto) {
	konto.os = {};
} (konto = window.konto));